import gql from 'graphql-tag';

export const loadStaticDataMutation = gql`
    mutation loadStaticData {
        loadStaticData
    }
`;
